const state = {
  menu: [],
};

const getters = {
  get: state => state.menu,
};

const mutations = {
  SET(state, data) {
    state.menu = _.isArray(data) ? data : [];
  },
};

const actions = {
  set({ commit }, data) {
    commit('SET', data)
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
